import theme from '@/style';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import React, {ReactNode} from 'react';

export interface DiceContainerProps {
  children?: ReactNode;
  itemNumber?: number;
  disabled?: boolean;
  onPress?: () => void;
  onDisabledPress?: () => void;
}

const DiceContainer = ({
  children,
  disabled = false,
  onPress = () => {},
  onDisabledPress = () => {},
}: DiceContainerProps) => {
  return (
    <NativeTouchableOpacity
      activeOpacity={disabled ? 1 : 0.8}
      onPress={() => {
        if (disabled) {
          onDisabledPress();
          return;
        }
        onPress();
      }}
      style={[
        // {width: itemWidth},
        theme.padding.tbs,
        theme.background.white,
        theme.flex.center,
        theme.borderRadius.m,
        // eslint-disable-next-line react-native/no-inline-styles
        {
          elevation: 4,
        },
      ]}>
      {children}
    </NativeTouchableOpacity>
  );
};

export default React.memo(DiceContainer);
